const ExternalUrlLink = ({ url, children }) => {
    return <span className="cursor-pointer text-azure-pastel select-none" onClick={() => window.open(url, '_blank')}>
        {children}
    </span>
}

export default ExternalUrlLink;